import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr12 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа при ръчно обработване на товари
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1.3а ръчно обработване на товари </b>се назначават лица, които са: навършили 18 години,
        преминали са медицински преглед и са преминали инструктаж по безопасността на труда.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2 .Не могат да се назначават</b> за товарно-разтоварни работи и да се използват за
        редовно ръчно пренасяне на товари лица, ненавършили 18 години, бременни жени и родилки до
        6-ия месец след раждане.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3 .Товаро-разтоварните работи </b>се извършват само от работници, които са обучени и
        инструктирани по здравословните и безопасни условия на труд и противопожарна охрана.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4 .Работниците се осигуряват </b>с необходимите лични предпазни средства и специално
        работно облекло, съгласно изискванията на нормативните актове за безопасност и здраве при
        работа и противопожарна охрана.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5 .Не се допускат до работа лица, които </b>са без изискващите се за съответния вид
        работа лични предпазни средства и не са инструктирани и обучени за използването им.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6 .На работното място се осигурява</b> преносима аптечка, заредена с медикаменти и
        превързочни материали за оказване на долекарска помощ.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7 .Не се допуска използването</b> на повдигателни съоръжения, които не отговарят на
        изискванията за безопасното им функциониране.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8 .Не се допуска използването </b>на немаркирани, неизправни и несъответсващи на теглата
        и характера на товарите, сменяеми товаро- захващащи приспособления.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9 . Повдигателните съоръжения </b>се обслужват само от обучен и правоспособен персонал,
        който е преминал периодична проверка на знанията.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10 .Поемането и оставянето на товара</b> трябва да се организира така, че да се избягват
        продължителните статични усилия и усукващи движения с товара около оста на тялото.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11 .При ръчни манипулации с товари </b>е необходимо:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • Да се взема подходяща поза, съобразно пренасяния товар и посока на движение;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • Товарът да се повдига чрез подходящо приклякване, а гърбът да се държи по възможност
          по-изправен, за да се поеме усилието на вдигане от мускулите на краката;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • Товар от земята да не се вдига чрез навеждане на кръста, понеже в този случай усилието
          на повдигане се поема от слабите мускули на кръста.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12 .Работникът, пренасящ товара</b>, трябва така да застане до него, че при вдигане да не
        става нужда да изменя положението на тялото си, а веднага да тръгне по посока на
        пренасянето.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>13 .При извършване на товарно-разтоварни работи </b>с тегло от 50 до 500 кг трябва да се
        използват подемно-транспортни машини. Допуска се също употребата на различни помощни
        приспособления и механизми (лотове, колички, вагонетки, крикове, полиспасти, лебедки и
        други) в зависимост от вида и големината на премествания товар.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>14 .При извършване на товарно-разтоварни работи </b>с товари над 5000 кг, задължително
        трябва да се използват подемно-транспортни машини. В изключителни случаи за единични товари
        се допуска употребата на по- прости товарно-разтоварни съоръжения (вагонетки, колички,
        полиспасти, лебедки и други), след като се вземат всички предпазни мерки за безопасна
        манипулация с товара.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>15 .Товари с тегло над нормата за ръчна обработка</b>, не по-тежки от 300 кг. по
        изключение могат да се пренасят ръчно от група работници под непосредственото наблюдение на
        опитен ръководител и при вземане на всички мерки за безопасна работа. Броят на работниците
        се определя така, че теглото, падащо се на един работник, да не надхвърля максимално
        допустимото.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>16 .Всички товари, които се хващат отдолу</b>, трябва да бъдат поставени върху подложки
        или да имат опаковки, които да гарантират свободна височина между дъното на товара и пода
        (земята) минимум 50 мм.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>17 .При ръчно пренасяне на товари </b>всеки работник трябва да гледа пред себе си и да не
        отклонява вниманието си в странични неща.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>18 .Когато естеството на работа е такова, че</b> се изисква постоянно навеждане на
        работниците, необходимо е товарите, предназначени за пренасяне, да се нареждат на маси или
        платформи на височина 800 - 900 мм.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>19 .Всички товари, които имат остри ръбове</b>, като машини, ламарини, метални и стъклени
        листове, чембер и други, трябва да се хващат и пренасят само със съответните лични предпазни
        средства ( ръкавици, подложки и други )или ръчни захватни приспособления.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>20. При извършване на товарно-разтоварна работа </b>в условия на хлъзгав терен (поледица,
        сняг ) е необходимо да се вземат мерки за избягване подхлъзвания на работниците, като за
        целта площадките трябва да се посипват с пясък, сгур и други.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>21. При пренасяне на товари </b>на рамо от двама работници, товарът се поставя на едно и
        също рамо.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>22. На всяка работна група трябва да </b>се назначава отговорник.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>23. Преди започване отговорникът на групата </b>е длъжен:
      </Typography>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • да постави план за извършване на работата и да запознае с него членовете на бригадата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • да провери състоянието на ръчните захватни и работни приспособления, личните предпазни
          средства и специялното работно облекло;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • заедно с работниците да огледа и подготви пътя на придвижване на товара, а също така и
          местата за складирането му, като пътя на придвижване трябва да бъде различен от странични
          предмети, а преходните мостове да бъдат изправни;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • преди преместване на товара, особено на тежките, трябва да се провери и ясно напише
          брутното им тегло, ако не е означено.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>24. Да не повдигат, хвърлят и оставят товарите</b>, когато се пренасят от повече от един
        работник, по-рано от подаване на команда от бригадира или отговорника на групата, което се
        извършва едновременно от всички работници след подаването на съответната команда.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>25. При хвърлянето на товара </b>във всички случаи товарно-разтоварните работници трябва
        да се намират от една страна на товара и да не го хвърлят по направление на близко намиращи
        се хора.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>26. При оставяне на товари трябва да </b>се вземат мерки, за да не се допуска притискане
        на ръцете и краката.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>27. При разкъсване на различни опаковки</b> се вземат предпазни мерки от наранявания от
        гвоздеи, чембер, тел, като се използват предпазни ръкавици, а гвоздеите се извадят.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>28. За работа с опасни товари </b>се допускат лица, медицински освидетелствани. Работата
        се извършва обикновено през деня.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>29. Допуска се при изключителни случаи </b>извършването на товарно- разтоварна работа с
        опасни товари през нощта при условия, че е осигурено достатъчно осветление на работните
        места с електрически лампи във взривобезопасно изпълнение.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>30. Товарно-разтоварните работи</b> с опасни товари се извършват на специализирани
        площадки и места за съхранение на тези товари, които трябва да бъдат съгласувани с
        медицинските и противопожарните органи и органите по безопасността на труда и под
        ръководството на специалист, определен от товароизпращача или товарополучателя.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>31. На товарно-разтоварните площадки </b>за преработка и съхранение на опасни товари е
        задължително поставянето на табели с надписи: &quot;ОТРОВНО &quot;, &quot;ОПАСНО&quot;,
        &quot;ВНИМАТЕЛНО&quot; и други подобни.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          32. <span style={styles.warning}>Забранява се </span>
        </b>
        през време на манипулирането на опасни товари пушенето, паленето на огън и приемането на
        храна.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>33. Работниците, извършващи товарно-разтоварни работи</b> с опасни товари, трябва
        периодично да преминават медицински прегледи според особеностите за безопасна работа с тези
        товари.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>34. Площадките за товарене, разтоварване, претоварване и съхраняване </b>
        на опасни товари, а така също местата за стоене на транспортните средства, предназначени за
        натоварване или разтоварване на тези товари, трябва да бъдат отдалечени на разстояние, не
        по-малко от 125 м от жилищни и производствени сгради, товарни складове, общи товарно-
        разтоварни площадки и складове и не по-близко от 50 м от главните пътища.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>35. При манипулиране, превозване и съхраняване</b> на лесновъзпламеняващи се взривоопасни
        и вредни за здравето товари трябва да се спазва Наредбата за превоз на товари, изискващи
        особени условия и всички други наредби, правилници и инструкции за безопасна работа с тях.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          36. <span style={styles.warning}>Забранява се </span>
        </b>
        складирането на вредни за здравето товари в общи складове и на товарно-разтоварни площадки,
        съвместно с други товари.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr12;
